import $axios from "../api/accessor";
import { $api } from "../api/api";
import { PaymentsFilterParams, PaymentsResponseType } from "../interfaces/admin.interface";

export const PaymentsService = {
  getPayments: async (filters: PaymentsFilterParams) => {
    const cleanParams: Record<string, any> = {};

    Object.entries(filters).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") return;
      cleanParams[key] = value;
    });

    try {
      const response = await $axios.get<PaymentsResponseType>($api("payments", cleanParams));
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return {
        data: error?.response?.data || null,
        status: error?.response?.status || 500,
        error,
      };
    }
  },
};
